(function () {
  'use strict';

  var focusableSelector = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var carouselTabindexAttribute = 'data-a11y-carousel-tabindex';
  var carouselInertAttribute = 'data-a11y-carousel-inert';
  var modalInertAttribute = 'data-a11y-modal-inert';
  var carouselUpdateScheduled = false;
  var modalUpdateScheduled = false;
  var activeModal = null;
  var modalOpener = null;

  function isVisible(element) {
    if (!element || !element.isConnected || element.hidden) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && style.opacity !== '0'
      && rect.width > 0
      && rect.height > 0;
  }

  function restoreCarouselTabindex(element) {
    var originalTabindex = element.getAttribute(carouselTabindexAttribute);

    if (originalTabindex === null) return;

    if (originalTabindex === 'none') {
      element.removeAttribute('tabindex');
    } else {
      element.setAttribute('tabindex', originalTabindex);
    }

    element.removeAttribute(carouselTabindexAttribute);
  }

  function disableCarouselControl(element) {
    if (!element.hasAttribute(carouselTabindexAttribute)) {
      element.setAttribute(
        carouselTabindexAttribute,
        element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : 'none'
      );
    }

    element.setAttribute('tabindex', '-1');
  }

  function labelCarousel(carousel, index) {
    var container;
    var heading;
    var label;

    carousel.setAttribute('role', 'region');
    carousel.setAttribute('aria-roledescription', 'carousel');

    if (carousel.hasAttribute('aria-label') || carousel.hasAttribute('aria-labelledby')) return;

    container = carousel.closest('section, featured-collection-new, best-seller, featured-collection-cards, [id^="shopify-section-"]');
    heading = container && container.querySelector('h1, h2, h3, h4, h5, h6');
    label = heading && heading.textContent.trim();

    carousel.setAttribute('aria-label', label || ('Content carousel ' + (index + 1)));
  }

  function syncCarousels() {
    carouselUpdateScheduled = false;

    document.querySelectorAll('[' + carouselTabindexAttribute + ']').forEach(restoreCarouselTabindex);
    document.querySelectorAll('[' + carouselInertAttribute + ']').forEach(function (cell) {
      cell.removeAttribute('inert');
      cell.removeAttribute(carouselInertAttribute);
    });

    document.querySelectorAll('.flickity-enabled').forEach(labelCarousel);

    document.querySelectorAll('.flickity-slider > [aria-hidden="true"]').forEach(function (cell) {
      cell.setAttribute('inert', '');
      cell.setAttribute(carouselInertAttribute, '');
      cell.querySelectorAll(focusableSelector).forEach(disableCarouselControl);
    });
  }

  function scheduleCarouselUpdate() {
    if (carouselUpdateScheduled) return;

    carouselUpdateScheduled = true;
    window.requestAnimationFrame(syncCarousels);
  }

  function pauseFocusedCarousel(event) {
    var carousel = event.target.closest && event.target.closest('.flickity-enabled');
    var instance;

    if (!carousel || !window.Flickity || typeof window.Flickity.data !== 'function') return;

    instance = window.Flickity.data(carousel);
    if (instance && typeof instance.pausePlayer === 'function') instance.pausePlayer();
  }

  function getFocusableElements(container) {
    return Array.prototype.filter.call(container.querySelectorAll(focusableSelector), function (element) {
      return isVisible(element) && !element.closest('[inert]') && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function getLayer(element) {
    var layer = 0;
    var current = element;
    var zIndex;

    while (current && current !== document.documentElement) {
      zIndex = parseInt(window.getComputedStyle(current).zIndex, 10);
      if (!isNaN(zIndex)) layer = Math.max(layer, zIndex);
      current = current.parentElement;
    }

    return layer;
  }

  function getTopModal() {
    var dialogs = Array.prototype.filter.call(
      document.querySelectorAll('[role="dialog"][aria-modal="true"]'),
      isVisible
    );

    return dialogs.sort(function (first, second) {
      return getLayer(first) - getLayer(second);
    }).pop() || null;
  }

  function clearManagedModalInert() {
    document.querySelectorAll('[' + modalInertAttribute + ']').forEach(function (element) {
      element.removeAttribute('inert');
      element.removeAttribute(modalInertAttribute);
    });
  }

  function makeModalBackgroundInert(dialog) {
    var branch = dialog;
    var parent = branch.parentElement;

    while (parent && parent !== document.documentElement) {
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling === branch || sibling.hasAttribute('inert')) return;
        if (sibling.matches('script, style, link')) return;

        sibling.setAttribute('inert', '');
        sibling.setAttribute(modalInertAttribute, '');
      });

      branch = parent;
      parent = parent.parentElement;
    }
  }

  function focusModal(dialog) {
    if (!dialog.hasAttribute('tabindex')) {
      dialog.setAttribute('tabindex', '-1');
      dialog.setAttribute('data-a11y-modal-tabindex', '');
    }

    dialog.focus({ preventScroll: true });
  }

  function syncModal() {
    var nextModal;

    modalUpdateScheduled = false;
    nextModal = getTopModal();

    if (nextModal === activeModal) return;

    clearManagedModalInert();

    if (!nextModal) {
      activeModal = null;

      if (modalOpener && modalOpener.isConnected && isVisible(modalOpener)) {
        modalOpener.focus({ preventScroll: true });
      }

      modalOpener = null;
      return;
    }

    if (!activeModal && document.activeElement !== document.body) {
      modalOpener = document.activeElement;
    }

    activeModal = nextModal;
    makeModalBackgroundInert(activeModal);
    focusModal(activeModal);
  }

  function scheduleModalUpdate() {
    if (modalUpdateScheduled) return;

    modalUpdateScheduled = true;
    window.requestAnimationFrame(syncModal);
  }

  function trapModalFocus(event) {
    var focusableElements;
    var first;
    var last;

    if (!activeModal || event.key !== 'Tab') return;

    focusableElements = getFocusableElements(activeModal);

    if (!focusableElements.length) {
      event.preventDefault();
      focusModal(activeModal);
      return;
    }

    first = focusableElements[0];
    last = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && (document.activeElement === first || document.activeElement === activeModal)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function keepFocusInModal(event) {
    if (!activeModal || activeModal.contains(event.target)) return;

    window.requestAnimationFrame(function () {
      if (activeModal) focusModal(activeModal);
    });
  }

  function nameInjectedControls() {
    document.querySelectorAll('.embeddedServiceHelpButton button:not([aria-label])').forEach(function (button) {
      button.setAttribute('aria-label', 'Open customer support chat');
    });
  }

  function initializeAccessibility() {
    syncCarousels();
    nameInjectedControls();
    scheduleModalUpdate();

    document.addEventListener('focusin', pauseFocusedCarousel);
    document.addEventListener('focusin', keepFocusInModal, true);
    document.addEventListener('keydown', trapModalFocus, true);

    new MutationObserver(function (mutations) {
      var childListChanged = mutations.some(function (mutation) {
        return mutation.type === 'childList';
      });
      var carouselChanged = mutations.some(function (mutation) {
        return mutation.type === 'childList' || mutation.attributeName === 'aria-hidden';
      });
      var modalChanged = mutations.some(function (mutation) {
        if (mutation.type === 'childList') return true;
        if (!mutation.attributeName) return false;

        if (['aria-modal', 'hidden', 'open', 'role'].indexOf(mutation.attributeName) !== -1) {
          return true;
        }

        var target = mutation.target;
        return target.matches('[role="dialog"], [aria-modal="true"]')
          || target.querySelector('[role="dialog"]')
          || (activeModal && target.contains(activeModal));
      });

      if (carouselChanged) scheduleCarouselUpdate();
      if (childListChanged) nameInjectedControls();
      if (modalChanged) scheduleModalUpdate();
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-modal', 'class', 'hidden', 'open', 'role', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccessibility);
  } else {
    initializeAccessibility();
  }
})();
